var _circle, _path;

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgShare(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, ["title", "titleId"]);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 18,
    height: 18,
    viewBox: "0 0 18 18",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 9,
    cy: 9,
    r: 9,
    fill: "#1891E5"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M3.5 9.29412C3.5 10.2671 4.29176 11.0588 5.26471 11.0588C5.73176 11.0588 6.15412 10.8735 6.47 10.5765L9.99412 12.5906C9.98353 12.6671 9.97059 12.7435 9.97059 12.8235C9.97059 13.7965 10.7624 14.5882 11.7353 14.5882C12.7082 14.5882 13.5 13.7965 13.5 12.8235C13.5 11.8506 12.7082 11.0588 11.7353 11.0588C11.2682 11.0588 10.8459 11.2441 10.53 11.5412L7.00588 9.52765C7.01647 9.45059 7.02941 9.37412 7.02941 9.29412C7.02941 9.21412 7.01647 9.13765 7.00588 9.06059L10.53 7.04706C10.8459 7.34412 11.2682 7.52941 11.7353 7.52941C12.7082 7.52941 13.5 6.73765 13.5 5.76471C13.5 4.79176 12.7082 4 11.7353 4C10.7624 4 9.97059 4.79176 9.97059 5.76471C9.97059 5.84471 9.98353 5.92118 9.99412 5.99824L6.47 8.01176C6.14471 7.70275 5.71337 7.53013 5.26471 7.52941C4.29176 7.52941 3.5 8.32118 3.5 9.29412Z",
    fill: "white"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgShare);
export default __webpack_public_path__ + "static/media/share.eb2b7c04.svg";
export { ForwardRef as ReactComponent };